import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { OrganizationDetailsService } from '../../organization-details.service';
import { ConfigService } from 'app/core/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'itpx-update-background-image',
  templateUrl: './update-background-image.component.html',
  styleUrls: ['./update-background-image.component.css']
})
export class UpdateBackgroundImageComponent implements OnInit {

  private cancelRoute: string = '/organization/organization-details';
  private component: string = 'agorabackgroundimage';
  private saveRoute: string = '/organization/organization-details';
  private allowedTypes = ['jpeg', 'png', 'bmp'];
  private imgSrc: string;
  private details: any;
  private id: string;
  private sub: Subscription;
  private defaultImage: string;
  private dimensions = { width: 1500, height: 350, comp: 'eq' };
  private bucket: string = this.configService.get('aws').uploadsBucket;
  private requirements: any;

  @Output() unsavedDataUploader = new EventEmitter();

  constructor(
    private service: OrganizationDetailsService,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router) {
    this.defaultImage = this.configService.get('images').defaultImage;
  }

  ngOnInit() {
    this.requirements = [
      ('Please make sure that your file meets the following requirements:'),
      ('File type is .' + this.allowedTypes.join(' or .')),
      ('Image size is ' + this.dimensions.width + 'x' + this.dimensions.height + 'px')];
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
      this.service.getDetails(this.id)
        .subscribe(
          body => {
            this.details = <any>body['data'];
            if (this.details.brandedPortalBackgroundImage == null || this.details.brandedPortalBackgroundImage.length == 0) {
              this.imgSrc = '';
            } else {
              this.imgSrc = this.details.brandedPortalBackgroundImage;
            }
          }
        );
    });
  }

  private unsavedData(e: any) {
    this.unsavedDataUploader.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details-edit/update-background-image/update-background-image.component.ts